import * as yup from 'yup'
import { REGEXP } from 'shared/consts/regExp'

export const userSchema = (checkUserEmail: (email: string) => Promise<boolean>, isExternalEmail?: boolean) => yup.object().shape({
  all_campaign: yup
    .boolean()
    .test('all_campaign', 'You have to add at least one Project', (status, { parent }) => {
      if(!status) return Boolean(parent.assigned_campaigns.length)
      return true
    }),
  first_name: yup.string().required('First Name is required.'),
  last_name: yup.string().required('Last Name is required.'),
  email: yup
    .string()
    .required('Email is required.')
    .email('Invalid email address.')
    .test('email', 'User already exist', async (email) => {
      if (typeof email === 'string') {
        return await checkUserEmail(email)
      }
      return false
    }),
  role: yup.string().required('Role is required.'),
  label_id: yup
    .string()
    .when('role', {
      is: (role?: string) => !role?.includes('space'),
      then: (schema) => schema.required('Label is required.'),
    }),
  space_id: yup
    .string()
    .when('role', {
      is: (role?: string) => role?.includes('space'),
      then: (schema) => schema.required('Space is required.'),
    }),
  country_code: yup.string().required('Label is required.'),
})

export const isEmail = (email: string): boolean => {
  return  REGEXP.EMAIL.test(email)
}